export const SET_CART = 'SET_CART';
export const SET_CART_QTY = 'SET_CART_QTY';
export const SET_CART_SUCCESS = 'SET_CART_SUCCESS';